// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Defines an API for sending a log message to a remote logger.
 */
export interface IRemoteLogMessageSender
{
  sendLogMessage(logLevel: LogLevel, format: string, args: any[]): void;
}